import { network } from '@root/utils'
import { ITranslatedName } from './accounts'
import { QueryFunction, PaginatedResponse } from './root'

export enum HeaderType {
  BALANCE_SHEET = 'B',
  INCOME_STATEMENT = 'I'
}

export interface IHeader {
  id: number
  name: string
  name_translations: ITranslatedName[]
  type: HeaderType
  parent_id: number | undefined
  parent_ids: number[]
  level: number
}

interface HeaderListProps {
  slug: string
}

export const fetchHeaders: QueryFunction<HeaderListProps, PaginatedResponse<IHeader>> = async (
  { slug },
  params = null
) => {
  const url = `/v1/business/${slug}/header/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

export const fetchHeader: QueryFunction<HeaderListProps & { headerId: number }, IHeader> = async ({
  slug,
  headerId
}) => {
  const url = `/v1/business/${slug}/header/${headerId}/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
